import { useEffect } from "react";

const RedirectToLoans = () => {
    useEffect(() => {
        window.location.replace("https://lendsimpli.com/elevate/");
    }, []);

    return null;
};

export default RedirectToLoans;
